import React from 'react';
import { DeviceType } from '../../../../../types/DeviceType';
import { Theme } from '../../../../../types/Theme';
import { t } from '../../../../../utils/i18n';
import { Dropdown, DropdownOption } from '../../../../Dropdown';
import * as s from './styles.scss';

export interface InstallmentsProps {
  value: number;
  installments: {
    minInstallments: number;
    maxInstallments: number;
  };
  deviceType: DeviceType;
  theme: Theme;

  onChange(nextInstallments: number): void;
}

const buildOptions = (min, max): DropdownOption[] => {
  const options: DropdownOption[] = [
    {
      id: 1,
      label: t('cc.installments.singlePayment'),
      value: 1,
    },
  ];

  for (let i = Math.max(min, 2); i <= max; i++) {
    options.push({ id: i, value: i, label: String(i) });
  }

  return options;
};

export const InstallmentsView: React.FunctionComponent<InstallmentsProps> = (
  props
) => {
  const { installments, theme, deviceType, value, onChange } = props;
  const label: string = t('cc.installments.title');
  const shouldShowLabel: boolean =
    theme !== Theme.modal || deviceType === 'desktop';

  return (
    <div data-hook="cashier-payments-method-installments-dropdown">
      {shouldShowLabel && <div className={s.installmentsTitle}>{label}</div>}
      <div className={s.dropdownWrapper}>
        <Dropdown
          selectedOptionId={value}
          options={buildOptions(
            installments.minInstallments,
            installments.maxInstallments
          )}
          onSelect={(option) => onChange(Number(option.id))}
          label={label}
        />
      </div>
    </div>
  );
};
InstallmentsView.displayName = 'InstallmentsView';
